import { useCallback, useEffect, useState } from 'react';

type ElementRect = {
  top: number;
  bottom: number;
  left: number;
  right: number;
  width: number;
  height: number;
  x: number;
  y: number;
};

export const useClientRect = (ref: React.RefObject<HTMLElement>) => {
  const [rect, setRect] = useState<ElementRect>({
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0,
    x: 0,
    y: 0,
  });

  const scrollResizeCallback = useCallback(() => {
    const current = ref.current;
    if (current) {
      const { top, bottom, left, right, width, height, x, y } =
        current.getBoundingClientRect();
      setRect({ top, bottom, left, right, width, height, x, y });
    }
  }, [ref]);

  useEffect(() => {
    scrollResizeCallback();
  }, [scrollResizeCallback]);

  useEffect(() => {
    const current = ref.current;
    current?.addEventListener('click', scrollResizeCallback);
    window.addEventListener('scroll', scrollResizeCallback);
    window.addEventListener('resize', scrollResizeCallback);
    return () => {
      current?.removeEventListener('click', scrollResizeCallback);
      window.removeEventListener('scroll', scrollResizeCallback);
      window.removeEventListener('resize', scrollResizeCallback);
    };
  }, [scrollResizeCallback, ref]);

  return rect;
};
